export default __webpack_public_path__ + "static/media/903.e0d101dd.png";